import { render, staticRenderFns } from "./BFormGeneral.vue?vue&type=template&id=4fcdd0a5&scoped=true&"
import script from "./BFormGeneral.vue?vue&type=script&lang=js&"
export * from "./BFormGeneral.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fcdd0a5",
  null
  
)

export default component.exports